import Base from '../base';
import { initializeSelect2, destroySelect2 } from '../../packs/select2Utils';

export default class Index extends Base {
    load() {
        initializeSelect2();
        this.initializeSearchForm();
    }

    initializeSearchForm() {
        const searchForm = document.querySelector('#asset_search, #search-form, form[role="search"]');

        if (searchForm) {
            searchForm.addEventListener('submit', (event) => {
                event.preventDefault();
                const searchTerm = searchForm.elements['table_search'].value || '';
                console.log("Termine di ricerca:", searchTerm);
                searchForm.submit();
            });
        }
    }
}